export default "__VITE_ASSET__DH9u95gQ__"